import { IIrctcPayload } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/core-ui";

export const isIrctcCart = (irctcData?: IIrctcPayload) => !isEmpty(irctcData);
